import { useEffect } from 'react';

/**
 * A card publishes its own health state to its stripe.
 *
 * RULE (design pass 12, locked): the stripe carries STATUS ONLY. A card with
 * a health state colours it from --km-ok / --km-wait / --km-late. A card with
 * no health state leaves it neutral. It never carries category or brand.
 *
 * The stripe is painted by the page grid as a sibling of the card, so a
 * variable set on the card's own root cannot reach it. The value is written
 * onto the grid item instead; the stripe reads
 * var(--km-card-accent-live, var(--km-card-accent)).
 */
export function useLiveAccent(ref, tone) {
  useEffect(() => {
    const item = ref.current?.closest('[data-km-card]');
    if (!item) return;
    // DESIGN PASS 15, replaces the pass 12 ruling: a card that is FINE is
    // neutral. Only wait and late colour a stripe, so colour is rare and
    // always means act. --km-ok stays correct inside a card, never here.
    if (!tone || tone === 'ok') {
      item.style.removeProperty('--km-card-accent-live');
      return;
    }
    const token = tone === 'wait' ? 'var(--km-wait)' : 'var(--km-late)';
    item.style.setProperty('--km-card-accent-live', token);
    return () => item.style.removeProperty('--km-card-accent-live');
  }, [ref, tone]);
}

export default useLiveAccent;
